import moment from 'moment-timezone';
function toUKTime(ts) {
  return moment(ts).tz('Europe/London');
}
export function toISO(ts) {
  return moment(ts).toISOString();
}
export function formatDate(ts) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'DD MMM YYYY';
  return toUKTime(ts).format(format);
}
export function formatUnixTimeStamp(ts) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'DD MMM YYYY';
  return moment.unix(ts).utc().format(format);
}
export function timeRemaining(date) {
  var delta = toUKTime(date).diff(toUKTime());
  return moment.duration(delta).humanize(true);
}
export var updateDate = function updateDate(path) {
  return function (obj) {
    return obj.updateIn(path, function (date) {
      return date && moment(date);
    });
  };
};
export var normalizeDate = function normalizeDate(date) {
  var isTimezoneMissing = date && date.length === 10; //2019-01-19
  return isTimezoneMissing ? "".concat(date, "T12:00:00.000Z") : date;
};
export function durationRemaining(date) {
  if (!date) return '';
  var delta = toUKTime(date).diff(toUKTime());
  var duration = moment.duration(delta);
  var daysLeft = duration.asDays();
  var hoursLeft = duration.asHours();
  var minutesLeft = duration.asMinutes();
  var isRemaining = minutesLeft >= 0;
  if (!isRemaining) return '';
  if (daysLeft >= 1) {
    var days = Math.round(daysLeft);
    return "".concat(days, " day").concat(days === 1 ? '' : '(s)');
  } else if (hoursLeft >= 1) {
    var hours = Math.round(hoursLeft);
    return hours === 24 ? '1 day' : "".concat(hours, " hour").concat(hours === 1 ? '' : 's');
  } else if (minutesLeft >= 1) {
    var minutes = Math.round(minutesLeft);
    return minutes === 60 ? '1 hour' : "".concat(minutes, " minute").concat(minutes === 1 ? '' : 's');
  } else {
    return '1 minute';
  }
}
export function dateNDaysInPast(N) {
  return toISO(moment().subtract(N, 'days'));
}
export function dateNMinutesInPast(N) {
  return toISO(moment().subtract(N, 'minutes'));
}
export function currentDate() {
  return toISO(moment());
}
export function shortDateAtTime(ts) {
  return formatDate(ts, 'DD MMM YYYY [at] HH:mm');
}
export function shortTime(ts) {
  return formatDate(ts, 'HH:mm');
}
export function shortDate(ts) {
  return formatDate(ts, 'DD MMM YYYY');
}